// Constants
const FETCH_CLINICAL_MEDICATIONS                = 'FETCH_CLINICAL_MEDICATIONS';
const FETCH_CLINICAL_MEDICATIONS_START          = 'FETCH_CLINICAL_MEDICATIONS_START';
const FETCH_CLINICAL_MEDICATIONS_SUCCESS        = 'FETCH_CLINICAL_MEDICATIONS_SUCCESS';
const FETCH_CLINICAL_MEDICATIONS_FAIL           = 'FETCH_CLINICAL_MEDICATIONS_FAIL';
const FETCH_MEDICATION_LIST_REQUEST             = 'FETCH_MEDICATION_LIST_REQUEST';
const FETCH_MEDICATION_LIST_START               = 'FETCH_MEDICATION_LIST_START';
const FETCH_MEDICATION_LIST_SUCCESS             = 'FETCH_MEDICATION_LIST_SUCCESS';
const FETCH_MEDICATION_LIST_FAIL                = 'FETCH_MEDICATION_LIST_FAIL';
const FETCH_MEDICATION_LIST_CANCEL              = 'FETCH_MEDICATION_LIST_CANCEL';
const SET_SELECTED_MEDICATION                   = 'SET_SELECTED_MEDICATION';
const RESET_MEDICATION_LIST                     = 'RESET_MEDICATION_LIST';

export {
  FETCH_CLINICAL_MEDICATIONS,
  FETCH_CLINICAL_MEDICATIONS_START,
  FETCH_CLINICAL_MEDICATIONS_SUCCESS,
  FETCH_CLINICAL_MEDICATIONS_FAIL,
  FETCH_MEDICATION_LIST_REQUEST,
  FETCH_MEDICATION_LIST_START,
  FETCH_MEDICATION_LIST_SUCCESS,
  FETCH_MEDICATION_LIST_FAIL,
  FETCH_MEDICATION_LIST_CANCEL,
  SET_SELECTED_MEDICATION,
  RESET_MEDICATION_LIST
};
